import React from 'react';
import { useEffect, useState } from 'react';
import { useChatHistory } from '@Context/ChatHistoryContext';
import MoonLoader from 'react-spinners/MoonLoader';
import { useAuth } from '@Context/CognitoAuthProvider';
import { aiChatAPI } from '@Lib/axios/ai-chat';

interface ModalProps {
  isOpen: boolean;
  message: string;
  onCancel: () => void;
}

const DeleteChatModal: React.FC<ModalProps> = ({
  message,
  isOpen,
  onCancel,
}) => {
  const { state, dispatch } = useChatHistory();
  const { currentChatId } = state;

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');

  const { logout } = useAuth();

  const aiChat = aiChatAPI(logout);

  useEffect(() => {
    if (aiChat.deleteChatHistory.length === 0) {
      setLoading(true);
      () => setLoading(false);
    }
  }, []);

  const deleteChat = async (chatId: string) => {
    setLoading(true);
    setStatus('Deleting chat...');
    try {
      await aiChat.deleteChatHistory(chatId);
      dispatch({ type: 'REMOVE_CHAT_HISTORY', payload: { id: chatId } });
      dispatch({ type: 'SET_CURRENT_CHAT', payload: { id: null } });
      setStatus('Chat deleted successfully');
      onCancel();
    } catch (error) {
      setStatus('Failed to delete chat');
    } finally {
      setLoading(false);
    }
    console.log(status);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
      <div className="m-10 rounded-lg bg-white p-6 shadow-lg">
        <h2 className="mb-4 text-xl font-bold">Delete Chat?</h2>
        <p className="mb-4 text-sm">
          <strong>{message}</strong> will be deleted.
        </p>
        {loading ? (
          <div className="flex justify-center">
            <MoonLoader size={50} color="#071D49" />
          </div>
        ) : (
          <div className="flex justify-end gap-2">
            <button
              onClick={onCancel}
              className="rounded-lg bg-gray-300 px-4 py-2 hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                if (currentChatId) {
                  deleteChat(currentChatId);
                }
              }}
              className="rounded-lg bg-red-500 px-4 py-2 text-white hover:bg-red-600"
            >
              Confirm
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeleteChatModal;
